module.exports = __webpack_public_path__ + "img/overview-header-right.a495d0fc.svg";